export default __webpack_public_path__ + "static/media/SJA1280.34I-38819_-22739_0.cda2abbe.jpg";